import { render, staticRenderFns } from "./VirtualTable.vue?vue&type=template&id=7245cee9&scoped=true"
import script from "./VirtualTable.vue?vue&type=script&lang=js"
export * from "./VirtualTable.vue?vue&type=script&lang=js"
import style0 from "./VirtualTable.vue?vue&type=style&index=0&id=7245cee9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7245cee9",
  null
  
)

export default component.exports